import { styled } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { TableCell } from './TableCell';
export const TableCellStyled = styled(TableCell, shouldNotForwardProps('copyValue'))(({ theme }) => ({
    ':hover': {
        color: theme.palette.primary.main,
    },
}));
